import BankNoteProject from "./BankNote.png"
import PersonalAssistant from "./PersonalAssistant.png"
import BookFinder from "./BookFinder.png"
import maskDetector from "./maskDetector.png"
import ZodiacApp from "./ZodiacApp.png"
import SentenceTagging from "./SentenceTagging.png"
const products = [
    {
        id: 1,
        img: BankNoteProject,
        link:"https://flassger-banknote.herokuapp.com/apidocs/#/default/get_predict",
        title: "Bank Currency Detector",
    },
    {
        id: 2,
        img:PersonalAssistant,
        link:"https://github.com/Anirudh-thakur/Personal-Assistant",
        title: "Personal Assistant",
    },
    {
        id: 3,
        img:BookFinder,
        link:"https://arcane-waters-81402.herokuapp.com/",
        title: "Book Search API",
    },
    {
        id: 4,
        img:maskDetector,
        link:"https://github.com/Anirudh-thakur/Mask-Detection",
        title: "Mask-Detection",
    },
    {
        id: 5,
        img:ZodiacApp,
        link:"https://lit-gorge-51305.herokuapp.com/",
        title: "Zodiac App",
    },
    {
         id: 6,
        img:SentenceTagging,
        link:"https://github.com/Anirudh-thakur/SentenceTagging",
        title: "Sentence Tagging",
    }
]

export default products